module.exports = __webpack_public_path__ + "static/media/about.e9c56a6e.jpg";